import { relations } from 'drizzle-orm'
import {
  type AnyPgColumn,
  boolean,
  index,
  pgTable,
  text,
  timestamp,
  unique,
  uuid,
} from 'drizzle-orm/pg-core'
import { users } from '../schema'
import { tenants } from './tenants'

// Organization Members
export const organizationMembers = pgTable(
  'organization_members',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    userId: uuid('user_id')
      .notNull()
      .references(() => users.id),
    employeeNumber: text('employee_number'),
    departmentName: text('department_name'),
    positionName: text('position_name'),
    parentId: uuid('parent_id').references((): AnyPgColumn => organizationMembers.id),
    isActive: boolean('is_active').notNull().default(true),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id, { onDelete: 'cascade' }),
    createdAt: timestamp('created_at').notNull().defaultNow(),
    updatedAt: timestamp('updated_at').notNull().defaultNow(),
  },
  (table) => ({
    tenantUserUnique: unique().on(table.tenantId, table.userId),
    userIdIdx: index('organization_members_user_id_idx').on(table.userId),
    parentIdIdx: index('organization_members_parent_id_idx').on(table.parentId),
    tenantIdIdx: index('organization_members_tenant_id_idx').on(table.tenantId),
  }),
)

// Relations
export const organizationMembersRelations = relations(organizationMembers, ({ one, many }) => ({
  user: one(users, { fields: [organizationMembers.userId], references: [users.id] }),
  parent: one(organizationMembers, {
    fields: [organizationMembers.parentId],
    references: [organizationMembers.id],
    relationName: 'parentChild',
  }),
  children: many(organizationMembers, { relationName: 'parentChild' }),
}))

// Type exports
export type OrganizationMember = typeof organizationMembers.$inferSelect
export type NewOrganizationMember = typeof organizationMembers.$inferInsert
